<template>
    <div>
        <slot v-if="!inprogress"></slot>
        <div class="wait_indicator center-block" v-else>
            <i alt="wait" class="center-block fa fa-spinner fa-spin" />
        </div>
    </div>

</template>

<script>
    import vue from 'vue';

    export default vue.extend({
        props: {
            inprogress: {type:Boolean, required: true},
            action: {type:String,required: false, default: 'unmount'},
        },
        data(){
            let src;
            src = "/images/spinner.gif";

            return {
                src
            }
        },
        name: "WaitIndicator"
    });
</script>
